'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PGS_ENDPOINT = exports.PGS_ENDPOINT = 'https://pgc.adobe.io/api/discovery';
var MAX_LENGTH = exports.MAX_LENGTH = 256;
var COLLABORATOR_TAG = exports.COLLABORATOR_TAG = 'COLLABORATOR';
var OWNER_TAG = exports.OWNER_TAG = 'OWNER';
var ANNOTATOR_TAG = exports.ANNOTATOR_TAG = 'ANNOTATOR';